import { AppRouter } from './routes/AppRouter';
import './App.css';
import './assets/css/register.css'
import './assets/css/header.css'
import './assets/css/home.css'
import './assets/css/chat.css'
import './assets/css/deposit.css'
import './assets/css/cricket.css'
import './assets/css/profile.css'
import './assets/css/loders.css'
import './assets/css/reciept.css'
import './assets/css/web.css'
import './assets/css/responsive.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import './assets/css/global.css'
import './assets/css/style.css'
import './assets/css/verify.css'
import './assets/css/plinko.css'
import './assets/css/mineWeb.css'
import './assets/css/aviator.css'
import Toasts from './components/toasts';
import { RootState } from './app/store';
import { useSelector } from 'react-redux';
import { useEffect, useRef } from 'react';
import { SOCKET } from "./services/constants";


function App() {
  const toastItems = useSelector((state: RootState) => state.toast.toasts);
  const iframeRef = useRef<HTMLIFrameElement>(null);
  
  useEffect(() => {   
   const isConnected = sessionStorage.getItem('isConnect');

    if (iframeRef.current && !isConnected) {
      iframeRef.current.src = SOCKET.SOCKET_SERVER_URL+':'+SOCKET.SOCKET_PORT;
      sessionStorage.setItem('isConnect', 'true'); 
      
      setTimeout(() => {      
        //console.clear();
      }, 300);
      
    }
    

    // eslint-disable-next-line
  }, []);
  
  return (
    <>
      <iframe
        ref={iframeRef}
        style={{ display: 'none' }}
        title="ping-server"
      />
      <Toasts {...toastItems} />
      <AppRouter />
    </>
  );
}

export default App;
